export const LEGACY_SALES_API_PATH = '/api/register_sales'

export const DATE_BASED_SALES_API_VERSION = '2026-04'
export const DATE_BASED_SALES_API_PATH = `/api/${DATE_BASED_SALES_API_VERSION}/sales`
